export const networking = {
  'QrBadge': 'Insignia QR',
  'seeAll': 'Ver todo',
  'newcommers': 'New Networkers',
  'checkThemOut': '¡Míralos!',
  'topicsToDiscuss': 'Temas para discutir',
  'OneOnOneMeet': 'Encuentro 1:1',
  'learnMoreNetworking': 'Aprende más sobre Networking Hub',
  'scanQrCode': 'Escanear código QR',
  'myBadge': 'Mi insignia',
  'message': 'Mensaje',
  'scannedBadge': 'Insignia escaneada',
  'viewProfile': 'Ver perfil',
  'userRatingDetails': 'Detalles de la calificación del usuario',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Puntuación total:',
  'scoreComposedOf': 'Esta puntuación se compone de:',
  'confirmationText': '¿Estás seguro? Esto no se puede deshacer.',

  'welcomeMessage': '¡Bienvenido a <strong>Networking Hub</strong>, donde las conexiones cobran vida! Así es como funciona:',
  'connectingMadeSimpleTitle': 'Conectar hecho simple',
  'connectingMadeSimpleDescription':
    'Networking Hub ofrece actividades estructuradas y niveles para ayudarte a conectar de manera efectiva:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Explora los perfiles de los nuevos miembros, agrégales a tu lista corta y envíales mensajes. ¡Puedes conectarte con ellos personalmente!',
  'shortlistDescription':
    '<strong>Shortlist:</strong> Una vez que muestras interés en alguien, esa persona se agrega a tu lista corta.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Cuando te contactas y recibes respuesta, esa persona pasa a estas categorías.',
  'skipDescription': '<strong>Skip:</strong> ¿No estás interesado? ¡Simplemente salta el perfil y sigue adelante!',

  'enhancedNetworkingActivitiesTitle': 'Actividades de red mejoradas',
  'enhancedNetworkingActivitiesDescription': 'Además de las conexiones directas, el Hub incluye:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Explora temas que te interesen y conéctate con los autores o participantes. Únete a discusiones en línea o programa reuniones en grupo para profundizar en esos temas.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Administra solicitudes de reuniones, haz un seguimiento de las reuniones programadas y organiza tu agenda fácilmente.',

  'gamificationTitle': 'Gamificación para diversión y compromiso',
  'gamificationDescription':
    'Aumenta tu actividad con una tabla de clasificación que sigue tus puntos y muestra a los networkers más activos. Aquí te mostramos cómo puedes ganar puntos:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1.000 puntos:</strong> Completa tu perfil (incluyendo una foto).',
    points1000PushNotifications: '<strong>1.000 puntos:</strong> Activa las notificaciones push.',
    points100SendMeetingRequest: '<strong>100 puntos:</strong> Envía una solicitud de reunión 1:1.',
    points400GetAcceptedRequest: '<strong>400 puntos:</strong> Obtén la aceptación de tu solicitud de reunión 1:1.',
    points400AcceptRequest: '<strong>400 puntos:</strong> Acepta una solicitud de reunión 1:1.',
    points100DeclineRequest: '<strong>100 puntos:</strong> Rechaza una solicitud de reunión 1:1.',
    points400CreateDiscussion: '<strong>400 puntos:</strong> Crea un tema de discusión.',
    points50LikeDiscussion: '<strong>50 puntos:</strong> Dale "me gusta" a un tema de discusión.',
    points200PostFirstComment: '<strong>200 puntos:</strong> Cada vez que publiques tu primer comentario en otro tema.',
    points100LikeOnTopic: '<strong>100 puntos:</strong> Obtén un "me gusta" en tu tema.',
    points200UniqueCommenter: '<strong>200 puntos:</strong> Obtén un comentarista único en tu tema.',
    points100LikeShortlistUser: '<strong>100 puntos:</strong> Dale "me gusta"/añade a un usuario a tu lista corta.',
    points50SkipUser: '<strong>50 puntos:</strong> Salta a un usuario.',
    points200StartChat: '<strong>200 puntos:</strong> Inicia un chat (contactado).',
    points300GetChatResponse: '<strong>300 puntos:</strong> Recibe una respuesta en el chat (conectado).',
    points400RespondToChat: '<strong>400 puntos:</strong> Responde a una solicitud de chat (conectado).',
    points500SpeedNetworking: '<strong>500 puntos:</strong> Por cada sesión de networking rápido.'
  },

  'finalMessage':
    'Aprovecha al máximo el Networking Hub, descubre nuevas oportunidades y sube en la clasificación mientras te conectas y te involucras con profesionales afines!',

  'manageMeeting': 'Gestionar reunión',
  'addToCalendar': 'Agregar al calendario',
  'cancel': 'Cancelar',
  'accept': 'Aceptar',
  'accept&addToCalendar': 'Aceptar y agregar al calendario',
  'editDetails': 'Editar detalles',
  'reject': 'Rechazar',
  'delete': 'Eliminar',
  'exportContact': 'Exportar contacto',
  'scheduleNewOneOnOne': 'Programar un nuevo 1:1',
  'initiatedBy': 'Iniciado por',
  'rejectedBy': 'Rechazado por',
  'you': 'tú',
  'meetPassed': 'La reunión ha pasado',
  'meetInProgress': 'En progreso',

  'myOneOnOne': 'Mi 1:1',

  'speed': {
    history: 'Historial',
    minutes: 'minutos',
    users_available: 'disponibles',
    rules: 'Reglas',
    activate: 'Activar',
    matching: 'Emparejando...',
    start: 'Comenzar',
    find_a_user: 'Encuentra un usuario con la misma imagen',
    find_a_user_number: 'Encuentra un usuario con el mismo número',
    waiting: 'Esperando...',
    speaking_now: 'Hablando ahora',
    networking_topics: 'Temas de networking',
    session_ended: 'Sesión finalizada',
    find_next_partner: 'Buscar siguiente pareja',
    find_next_group: 'Buscar el siguiente grupo',
    partner_wasnt_ready: 'La pareja no estaba lista',
    partner_wasnt_ready_description: 'Parece que la pareja no estaba lista para la conversación. ¡Vamos a buscar otra!',
    start_matching: 'Comenzar emparejamiento'
  }
}
